/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamResultsAliases {
  AUTOCOMPLETE_CLASSIFICATION = 'autocomplete-classification',
  AUTOCOMPLETE_STATUS = 'autocomplete-status',
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  CARD_EXAMS_LIST_ITEM = 'card-exams-list-item',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_INITIAL_DATE = 'date-picker-initial-date',
  DECK_EXAMS = 'deck-exams',
  FETCH_EXAM_CLASSIFICATION = 'fetch-exam-classification',
  FETCH_EXAM_LIST = 'fetch-exam-list',
  FETCH_EXAM_STATUS = 'fetch-exam-status',
  FETCH_EXAMS = 'fetch-exams',
  FILTER_EXAMS_LIST = 'filter-exams-list',
  FILTER_FIELD_EXAM_CLASSIFICATION = 'filter-field-exam-classification',
  FILTER_FIELD_EXAM_STATUS = 'filter-field-exam-status',
  FILTER_FIELD_EXAM_TYPE = 'filter-field-exam-type',
  FILTER_FIELD_FROM_DATE = 'filter-field-from-date',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_EXAMS_RESULT = 'layout-exams-result',
  LAYOUT_EXAMS_RESULT_LIST = 'layout-exams-result-list',
  MAPPER_CLASSIFICATION = 'mapper-classification',
  MAPPER_STATUS = 'mapper-status',
  MAPPER_TYPES = 'mapper-types',
  PANEL_0 = 'panel-0',
  PANEL_EXAMS = 'panel-exams',
  TEXT_CLASSIFICATION = 'text-classification',
  TEXT_STATUS = 'text-status',
  TEXT_TYPE = 'text-type',
}
export { ExamResultsAliases };
